import { render, staticRenderFns } from "./GoodsSeriesSelect.vue?vue&type=template&id=235a66cf&scoped=true&"
import script from "./GoodsSeriesSelect.vue?vue&type=script&lang=js&"
export * from "./GoodsSeriesSelect.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSeriesSelect.vue?vue&type=style&index=0&id=235a66cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235a66cf",
  null
  
)

export default component.exports